export const ContactSalesComponentENUSTranslations = {
  contactSalesTitle:
    'Use data and AI-driven forecasting to power your business',
  contactSalesCallout: 'GET STARTED',
  contactSalesDescription:
    'Learn how we improve your decisions and outcomes in an online call with a 4intelligence expert',
  contactSalesBackgroundAlt: 'Contact Sales background',
};
